// Tipi di evento sanitario e palette condivisa (bg = pieno, fg = testo su bg, light = sfondo tenue, txt = testo su bianco)
export const EVENTO_TIPI = [["scompensato", "Scompensato"], ["ossigeno", "Ossigeno terapia"], ["glicemica", "Glicemica"], ["febbre", "Febbre"], ["influenza", "Influenza"], ["covid", "COVID-19"], ["gastroenterite", "Gastroenterite"], ["ivu", "Infezione vie urinarie"], ["cutanea", "Infezione cutanea / scabbia"], ["altro", "Altro"]];
const RED = { bg: "#dc2626", fg: "#ffffff", light: "#fee2e2", txt: "#b91c1c" };
export const EVENTO_COLORS = {
  scompensato: { bg: "#92400e", fg: "#ffffff", light: "#fde7c7", txt: "#92400e", ab: "SCO" },
  ossigeno: { bg: "#38bdf8", fg: "#ffffff", light: "#e0f2fe", txt: "#0284c7", ab: "O2" },
  glicemica: { bg: "#fde047", fg: "#713f12", light: "#fef9c3", txt: "#ca8a04", ab: "GLI" },
  febbre: { ...RED, ab: "FEB" },
  influenza: { ...RED, ab: "INF" },
  covid: { ...RED, ab: "COV" },
  gastroenterite: { ...RED, ab: "GAS" },
  ivu: { ...RED, ab: "IVU" },
  cutanea: { ...RED, ab: "CUT" },
  altro: { ...RED, ab: "ALT" },
};
export const eventoColor = (tipo) => EVENTO_COLORS[tipo] || (tipo === "visita" ? VISITA_COLOR : EVENTO_COLORS.febbre);
export const VISITA_COLOR = { bg: "#0d9488", fg: "#ffffff", light: "#ccfbf1", txt: "#0f766e", ab: "VIS" };
export const EVENTO_LABEL = Object.fromEntries(EVENTO_TIPI);
export const O2_MODALITA = [["3h", "3 ore al giorno"], ["permanente", "Permanente"]];
export const O2_LABEL = Object.fromEntries(O2_MODALITA);
